import "./Features.css";

import { FaRainbow } from "react-icons/fa6";
import { FaTruck, FaMoneyBillWave, FaWhatsapp } from "react-icons/fa";

export default function Features() {
  return (
    <div className="features">

      <div className="feature-card">
        <div className="feature-icon">
          <FaRainbow />
        </div>

        <h3>Curated Quality</h3>
        <p>
          Premium baby & kids clothes, carefully selected with love 💖
        </p>
      </div>


      <div className="feature-card">
        <div className="feature-icon">
          <FaTruck />
        </div>

        <h3>Fast Delivery</h3>
        <p>
        Fast & reliable shipping 🚚
        </p>
      </div>


      <div className="feature-card">
        <div className="feature-icon">
          <FaMoneyBillWave />
        </div>

        <h3>Cash on Delivery</h3>
        <p>
          Pay when you receive your order. Easy & safe 💕
        </p>
      </div>


      <div className="feature-card">
        <div className="feature-icon">
          <FaWhatsapp />
        </div>

        <h3>WhatsApp Support</h3>
        <p>
          Need help? Chat with us anytime on WhatsApp 📱
        </p>
      </div>


    </div>
  );
}